@if (state.isVisible()) {
  <section class="connector-status" aria-label="Agent connectors">
    <button
      #connectorAnchor
      type="button"
      class="connector-status__trigger"
      aria-haspopup="dialog"
      (click)="toggleDetails($event, connectorAnchor)"
    >
      <i
        class="pi"
        [class.pi-spin]="state.isLoading() || state.isChecking()"
        [class.pi-spinner]="state.isLoading() || state.isChecking()"
        [class.pi-link]="!state.isLoading() && !state.isChecking()"
        aria-hidden="true"
      ></i>
      @if (state.isLoading() || state.isChecking()) {
        <span>Checking connectors</span>
      } @else if (state.missing().length; as missingCount) {
        <span>
          {{ missingCount }} connector{{ missingCount === 1 ? '' : 's' }} needs sign-in
        </span>
      } @else if (state.errorMessage()) {
        <span>Connector status unavailable</span>
      } @else if (state.hasAny()) {
        <span>Connectors ready</span>
      } @else {
        <span>Connector status unavailable</span>
      }
      <i class="pi pi-angle-down connector-status__chevron" aria-hidden="true"></i>
    </button>

    <p-popover
      #connectorPopover
      [appendTo]="'body'"
      styleClass="connector-status-popover"
      ariaLabel="Agent connector status"
    >
      <div class="connector-status__details">
        <div class="connector-status__heading">
          <div>
            <h2>Agent connectors</h2>
            <p>Connect the accounts this agent uses for related tools.</p>
          </div>
          <button
            type="button"
            class="connector-status__refresh"
            [disabled]="state.isChecking()"
            aria-label="Refresh connector status"
            (click)="refresh()"
          >
            <i
              class="pi pi-refresh"
              [class.pi-spin]="state.isChecking()"
              aria-hidden="true"
            ></i>
          </button>
        </div>

        @if (state.errorMessage()) {
          <p class="connector-status__error" role="alert">
            {{ state.errorMessage() }}
          </p>
        }

        <bds-scroll-region maxHeight="18rem" ariaLabel="Agent connector accounts">
          <ul class="connector-status__list">
            @for (requirement of state.requirements(); track requirement.mcpServerId) {
              <li class="connector-status__row">
                <div class="connector-status__copy">
                  <span class="connector-status__name">{{ requirement.displayLabel }}</span>
                  @if (state.isPending(requirement.mcpServerId)) {
                    <span class="connector-status__state">Updating...</span>
                  } @else if (!requirement.statusResolved) {
                    <span class="connector-status__state">Checking...</span>
                  }
                  @if (requirement.error) {
                    <span class="connector-status__row-error" role="alert">
                      {{ requirement.error }}
                    </span>
                  }
                </div>

                @if (requirement.statusResolved) {
                  @if (requirement.connected) {
                    <button
                      type="button"
                      class="connector-status__action connector-status__action--secondary"
                      [attr.data-connector-action]="'disconnect-' + requirement.mcpServerId"
                      [disabled]="state.isPending(requirement.mcpServerId)"
                      (click)="disconnect(requirement.mcpServerId)"
                    >
                      Disconnect
                    </button>
                  } @else {
                    <button
                      type="button"
                      class="connector-status__action"
                      [attr.data-connector-action]="'connect-' + requirement.mcpServerId"
                      [disabled]="state.isPending(requirement.mcpServerId)"
                      (click)="connect(requirement.mcpServerId)"
                    >
                      Connect
                    </button>
                  }
                }
              </li>
            }
          </ul>
        </bds-scroll-region>
      </div>
    </p-popover>
  </section>
}
